export default function MemberCard({ name, imagePath, title, description }) {
    return (
        <div className="section-company-member-card">
            {/*<img alt="profile" src={imagePath} />*/}
            <h4>{name}</h4>
            <p>{title}</p>
            <p style={{fontStyle:'italic'}}>{description}</p>
        </div>
    )
}